<div class="dialog-content-min">
  <form [formGroup]="stateForm">
    <div class="formgrid grid m-2">
      <div class="field col-12">
        <label for="statename" class="required-label">State Name<span class="maxchars">(Max 500 chars)</span><span>*</span></label>
        <input type="text" class="form-control" placeholder="Enter State Name" id="statename"
          formControlName="statename" required name="statename" pInputText> 
        <span class="errormessage"
          *ngIf="stateForm.get('statename').invalid && (stateForm.get('statename').dirty || stateForm.get('statename').touched)">
          {{getErrorMessage(stateForm ,validation_message,'statename')}}
        </span>
      </div>
    </div>

    <div class="formgrid grid m-2">
      <div class="field col-12">
        <label for="countryid" class="required-label">Country<span>*</span></label> 
        <p-dropdown [options]="countryOptions" optionLabel="countryname" optionValue="countryid"
          formControlName="countryid" appendTo="body" inputId="countryid" name="countryid" [filter]="true"
          placeholder="Select Country">
        </p-dropdown>
        <span class="errormessage" *ngIf="stateForm.get('countryid').invalid && stateForm.get('countryid').touched ">
          {{getErrorMessage(stateForm ,validation_message,'countryid')}}</span>
      </div>
    </div>

    <div class="formgrid grid m-2" *ngIf="isEdit">
      <div class="field col-12">
        <label for="activeflag"> Active Flag </label>
        <p-dropdown [options]="activeFlag" id="activeflag" [filter]="true" appendTo="body" name="activeflag"
          optionLabel="labelname" optionValue="value" placeholder="Select Flag"
          formControlName="activeflag"></p-dropdown>
        <span class="errormessage" *ngIf="stateForm.get('activeflag').invalid && stateForm.get('activeflag').touched ">
          {{getErrorMessage(stateForm ,validation_message,'activeflag')}}
        </span>
      </div>
    </div>
  </form>
</div>

<div class="custom-dialog-footer">
  <div class="mt-1"></div>
  <p-button class="m-1" label="Close" styleClass="customeclose"
    (click)="closemodal(stateForm,this.ref,'Are you sure you want to close?')"></p-button>
  <p-button class="m-1" *ngIf="!onlyView" label="{{saveTitle}}" styleClass="customesave"
    (click)="addState()"></p-button>
  <div class="mt-1"></div>
</div>